import script from "./Admin.vue?vue&type=script&lang=ts&setup=true"
export * from "./Admin.vue?vue&type=script&lang=ts&setup=true"

import "./Admin.vue?vue&type=style&index=0&id=2c125580&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c125580"]])

export default __exports__